/*** Librerías Laravel ***/
require("../bootstrap");

/*** Librerías externas ***/
window.moment = require("moment");

require("jquery-confirm");

// Font Awesome
require("@fortawesome/fontawesome-free/js/all.js");

/*** Librerías propias ***/
require("./common/translation");
require("./common/pnotify")
require(`./../../../vendor/trevenque/webdis-core/resources/js/front/commons/tools`);
require("./../../../vendor/trevenque/webdis-core/resources/js/front/commons/table-saw");
require("./../../../vendor/trevenque/webdis-core/resources/js/front/commons/element-saw");
require("./common/global");
require("./common/cookies");
require("./common/navbar");
require("./common/footer");
